/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TrackPointsPostRequest } from '../models/TrackPointsPostRequest';
import type { TrackPointsPostResponse } from '../models/TrackPointsPostResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TrackPointsService {

    /**
     * @param requestBody
     * @returns TrackPointsPostResponse OK
     * @throws ApiError
     */
    public static post(
        requestBody: TrackPointsPostRequest,
    ): CancelablePromise<TrackPointsPostResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/TrackPoints',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
